import { Router } from '@angular/router';
import { Component, ElementRef, Inject, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';

@Component({
    selector: 'home-trader-balance',
    templateUrl: './home-trader-balance.component.html',
    styleUrls: ['./home-trader-balance.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class HomeTraderBalanceComponent extends DialogPanelComponentContent implements OnInit {
    public tooltips: { [prop: string]: string } = {};
    public optionsChart: any;
    public haveFutureReleases: boolean = false;
    public investimentsSum: number;

    constructor(
        public dialogReference: MatDialogRef<HomeTraderBalanceComponent>,
        element: ElementRef,
        private store: Store<AppState>,
        private renderer: Renderer2,
        protected router: Router,
        @Inject(MAT_DIALOG_DATA) public data,
    ) {
        super(element, true);
    }

    public ngOnInit() {
        super.ngOnInit();
        this.startTips();
        this.optionsChart = { data: this.data.userFinancePosition, darkTheme: false };
        this.investimentsSum = this.data.userConsolidatePosition.totalFixedIncome
            + this.data.userConsolidatePosition.totalExchange
            + this.data.userConsolidatePosition.totalFunds;
    }

    public closeMenu() {
        super.close(this.dialogReference, null);
        this.renderer.removeClass(document.body, 'overflow--hidden');
    }

    public navigateTo(path: string) {
        this.router.navigateByUrl(`${path}`);
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }

    public startTips() {
        this.tooltips.withdraw = `
                <div>
                    <div class='pop-content'>
                        <h2>Disponível para saque</h2>
                        <p>
                            É o valor da sua conta corrente que não está investido ou sendo usado como garantia.
                            Taxas de corretagem, resgates de investimentos ou ganhos em Bolsa geralmente precisam de um ou dois dias úteis para serem calculados nesse valor.
                        </p>
                    </div>
                </div>
            `;

        this.tooltips.balance = `
                <div>
                    <div class='pop-content'>
                        <h2>Saldo projetado</h2>
                        <p>
                            É o seu valor em conta considerando lançamentos futuros, referentes aos seus investimentos em ações.
                            Você pode ver todos os lançamentos no seu extrato.
                        </p>
                    </div>
                </div>
            `;

        this.tooltips.guarantee = `
            <div>
                <p class="pop-content">Esse é o valor que pode ser utilizado para operações em renda variável quando não houver saldo suficiente em sua conta corrente. </p>
                <div class="limit-tooltip-bottom-warning">
                    <a href="https://blog.toroinvestimentos.com.br/trading/margem-de-garantia-o-que-e/" target="_blank"> Saiba mais sobre Margem de Garantia </a>
                    <img src="home/assets/svg-icons/arrow-line-right.svg" alt="">
                </div>
            </div>
        `;
    }

    public redirectGuarantees() {
        this.router.navigate(['/bolsa/meus-investimentos/garantias-disponiveis']);
    }
}
